import React from 'react'
import SignIn from '../Components/SignIn'

const SignInPage = () => {
    return (
        <div>
            <SignIn/>
        </div>
    )
}

export default SignInPage
